module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_DE-8a1eea8ab1c9ffc2928270b7504a578b.svg";